import { createContext, useContext } from 'react';
import type { PlaeeClient } from './plaee-client';
import type { RealtimeManager } from './realtime-manager';

export interface RealtimeManagerContextValue {
  manager: RealtimeManager;
  client: PlaeeClient;
}

export const RealtimeManagerCtx = createContext<RealtimeManagerContextValue | null>(null);

export function useRealtimeManager(): RealtimeManager {
  const ctx = useContext(RealtimeManagerCtx);
  if (ctx === null) throw new Error('useRealtimeManager: not inside <RealtimeManagerProvider>');
  return ctx.manager;
}

export function usePlaeeClient(): PlaeeClient {
  const ctx = useContext(RealtimeManagerCtx);
  if (ctx === null) throw new Error('usePlaeeClient: not inside <RealtimeManagerProvider>');
  return ctx.client;
}
